module.exports = __webpack_public_path__ + "static/media/store.79c25075.svg";